/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jack-henry/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import { BankModelDto } from "../";
import { HttpClient, RequestParams } from "./http-client";

@Injectable()
export class BanksClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags Banks
   * @name BanksGet
   * @summary Returns all Banks.
   * @request GET:/banks
   */
  banksGet = (params: RequestParams = {}) =>
    this.http.request<BankModelDto[], any>({
      path: `/banks`,
      method: "GET",
      format: "json",
      ...params,
    });
}
